// Configuration
const animationTopProgress = 0.3;
const animationBottomProgress = 0.7;
const progressRange = animationBottomProgress - animationTopProgress;

// Variables
let revealAnimationTicking = false;
let revealAnimationLastScrollPosition = 0;


function initializeTextRevealAnimationElements(animatableElementSelectors, rootElement = document) {
    // Inspired by https://www.bennadel.com/blog/4310-detecting-rendered-line-breaks-in-a-text-node-in-javascript.htm
    function extractLinesFromTextNode(textNode) {
        function collapseWhiteSpaces(value) {
            return (value.trim().replace(/\s+/g, ' '));
        }

        // Required for Safari
        textNode.textContent = collapseWhiteSpaces(textNode.textContent);
        // Variables
        const textContent = textNode.textContent;
        const range = document.createRange();
        let lines = [];
        let lineCharacters = [];
        // Iterate over characters
        for (let i = 0; i < textContent.length; i++) {
            // Set range from start to current character
            range.setStart(textNode, 0);
            range.setEnd(textNode, i + 1);
            // The list of rectangles refers to the currently rendered line
            const lineIndex = (range.getClientRects().length - 1);
            // If this is the first character of a new line: flush current line and set as first character
            if (!lines[lineIndex]) {
                lineCharacters = [];
                lines.push(lineCharacters);
            }
            // Push current character to current line
            lineCharacters.push(textContent.charAt(i));
        }
        // At this point, we have an array (lines) of arrays (characters). Let's
        // collapse the character buffers down into a single text value.
        lines = lines.map((characters) => collapseWhiteSpaces(characters.join('')));
        return lines;
    }

    function splitElementsIntoAnimations(animatableElement) {
        // Make sure that there is only a text node present
        animatableElement.innerHTML = animatableElement.textContent;
        // Split into lines
        const lines = extractLinesFromTextNode(animatableElement.firstChild);
        // Clear content
        animatableElement.innerHTML = '';
        // Add lines to be animated
        lines.forEach((line) => {
            const lineTextElement = document.createElement('span');
            lineTextElement.textContent = line;
            const lineMaskElement = document.createElement('span');
            lineMaskElement.classList.add('mask');
            const lineElement = document.createElement('span');
            lineElement.classList.add('text-reval-animation');
            lineElement.appendChild(lineTextElement);
            lineElement.appendChild(lineMaskElement);
            animatableElement.appendChild(lineElement);
            animatableElement.innerHTML += ' ';
        });
    }

    const animatableElements = rootElement.querySelectorAll(animatableElementSelectors.join(', '));
    animatableElements.forEach((animatableElement) => {
        splitElementsIntoAnimations(animatableElement);
    });
}

function updateRevealAnimationStates(scrollPosition) {
    function calculateAnimationProgress(elementProgress) {
        if (elementProgress < animationTopProgress) {
            return 1;
        } else if (elementProgress > animationBottomProgress) {
            return 0;
        } else {
            return 1 - ((elementProgress - animationTopProgress) / progressRange);
        }
    }

    const animatableLineElements = document.querySelectorAll('.text-reval-animation');
    const windowHeight = window.innerHeight;
    animatableLineElements.forEach((animatableElement) => {
        const boundingRect = animatableElement.getBoundingClientRect();
        const progress = boundingRect.top / windowHeight;
        const animationProgress = calculateAnimationProgress(progress);
        animatableElement.querySelector('.mask').style.transform = `translate3d(${animationProgress * 100}%, 0, 0)`;
    });
}

function handleProgressUpdateTrigger() {
    revealAnimationLastScrollPosition = window.scrollY;
    if (!revealAnimationTicking) {
        window.requestAnimationFrame(() => {
            updateRevealAnimationStates(revealAnimationLastScrollPosition);
            revealAnimationTicking = false;
        });
        revealAnimationTicking = true;
    }
}

const textRevealAnimatableElementSelectors = [
    '.text-banner.highlight .text-banner-heading'
];

window.addEventListener('load', () => {
    initializeTextRevealAnimationElements(textRevealAnimatableElementSelectors);
    handleProgressUpdateTrigger();
});

document.addEventListener('overlay-created', (event) => {
    const overlayContainer = event.detail.overlayContainer;
    overlayContainer.querySelector('.overlay-content').addEventListener('scroll', () => {
        handleProgressUpdateTrigger();
    });
});

document.querySelectorAll(textRevealAnimatableElementSelectors.join(', ')).forEach((element) => {

    new ResizeObserver(() => {
        initializeTextRevealAnimationElements(textRevealAnimatableElementSelectors);
    }).observe(element);
});

document.addEventListener('scroll', () => {
    handleProgressUpdateTrigger();
});

document.addEventListener('resize', () => {
    handleProgressUpdateTrigger();
});
